import { axios } from "../config";

function createStudent(data) {
  return axios.post("api/v1/students", data, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}
function updateStudent(student_id, data) {
  return axios.put(`api/v1/students/${student_id}`, data, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function fetchSubjects() {
  return axios.get("api/v1/subjects");
}

function fetchClass(data) {
  return axios.get("api/v1/levels", {
    params: data,
  });
}

function fetchSections(level_id) {
  return axios.get(`api/v1/classrooms?level_id=${level_id}`);
}

function fetchSchoolLevelStatistics(data) {
  return axios.get("api/v1/levels/statistics", {
    params: data,
  });
}

function updateLevel(id, data) {
  return axios.post(`api/v1/levels/${id}`, data);
}

function createLevel(data) {
  return axios.post("api/v1/levels", data);
}

function deleteLevel(id) {
  return axios.delete(`api/v1/levels/${id}`);
}

function fetchStudentList(data) {
  return axios.get("api/v1/students", {
    params: data,
  });
}

function fetchStudentDetails(id) {
  return axios.get(`api/v1/students/${id}`);
}

function fetchStudentNonAcademicActivities(id) {
  return axios.get(`api/v1/students/non-academic-activities?student_id=${id}`);
}

function fetchStudentCommunications(id) {
  return axios.get(`api/v1/students/communication?student_id=${id}`);
}

function fetchStudentPayments(id) {
  return axios.get(`api/v1/students/payments?student_id=${id}`);
}

function fetchStudentBursaries(id) {
  return axios.get(`api/v1/students/bursary?student_id=${id}`);
}

function createStudentBursary(data) {
  return axios.post("api/v1/students/bursary", data);
}

function fetchStudentAttendance(data) {
  return axios.get("api/v1/students/attendance", {
    params: data,
  });
}
function deleteStudent(id) {
  return axios.delete(`api/v1/students/${id}`);
}

function resendCredentialsStudents(data) {
  return axios.post("api/v1/students/send-sms", data);
}

function resendCredentialsParents(data) {
  return axios.post("api/v1/parents/send-sms", data);
}
function suspendStudent(data) {
  return axios.post("api/v1/students/suspend", data);
}

function bulkUploadStudent(formData) {
  return axios.post(`/api/v1/students/bulk-upload`, formData, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function getStudentPaymentHistoryForExport(data) {
  return axios.post(`api/v1/students/export-payments`, data, {
    responseType: "blob",
  });
}

function getStudentAttendanceForExport(classroomID, studentID) {
  return axios.get(
    `api/v1/students/export-attendance?classroom_id=${classroomID}&student_id=${studentID}`,
    { responseType: "blob" }
  );
}

function createParent(data) {
  return axios.post("api/v1/parents", data, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function updateParent(parent_id, data) {
  return axios.post(`api/v1/parents/${parent_id}`, data, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function exportStudents(params) {
  return axios.get("/api/v1/students/export", {
    responseType: "blob",
    params,
  });
}
function getStudentStatAttendance(params) {
  return axios.get("api/v1/attendence/students/stats", { params });
}
function getStudentAttendanceDetails(params) {
  return axios.get("api/v1/attendence/students", { params });
}
function sendRemainder(id) {
  return axios.post(`api/v1/attendence/send-reminder`, id);
}
function setPreferenceData(formData) {
  return axios.post(`api/v1/attendence/preference`, formData);
}

function getLevelsById(id) {
  return axios.get(`api/v1/attendence/students?level_id=${id}`);
}
export {
  getLevelsById,
  setPreferenceData,
  sendRemainder,
  getStudentAttendanceDetails,
  getStudentStatAttendance,
  resendCredentialsStudents,
  resendCredentialsParents,
  createStudent,
  fetchSubjects,
  fetchClass,
  fetchSections,
  fetchSchoolLevelStatistics,
  fetchStudentList,
  fetchStudentDetails,
  fetchStudentNonAcademicActivities,
  fetchStudentCommunications,
  fetchStudentPayments,
  fetchStudentBursaries,
  updateStudent,
  createStudentBursary,
  fetchStudentAttendance,
  deleteStudent,
  suspendStudent,
  getStudentAttendanceForExport,
  bulkUploadStudent,
  getStudentPaymentHistoryForExport,
  updateLevel,
  createLevel,
  deleteLevel,
  createParent,
  updateParent,
  exportStudents,
};
